<template>
    <div>
        <el-dialog
            title="打标记录详情"
            :visible.sync="dialog"
            width="900px"
            :close-on-click-modal="false"
            top="50px"
        >
            <div class="table">
                <el-table :data="tableData" fit style="border: 1px solid #eee;">
                    <el-table-column prop="account" :label="initCol[0]" align="center"></el-table-column>
                    <el-table-column width="150" :label="initCol[1]">
                        <template slot-scope="scope">
                            <el-popover trigger="hover" placement="top">
                                <p>{{ scope.row.url }}</p>
                                <div slot="reference" class="name-wrapper">{{ scope.row.url }}</div>
                            </el-popover>
                        </template>
                    </el-table-column>
                    <el-table-column prop="tag" align="center" :label="initCol[2]"></el-table-column>

                    <el-table-column align="center" width="120" prop="money_type" :label="initCol[3]">
                        <template slot-scope="scope">{{scope.row.result_msg}}</template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pages marginT-20 text-center">
                <el-pagination
                    @current-change="handleCurrentChange"
                    :current-page="page"
                    :page-size="10"
                    layout="total, prev, pager, next, jumper"
                    :total="total"
                ></el-pagination>
            </div>
            <div slot="footer" class="dialog-footer text-center">
                <!-- <el-button @click="dialog = false">取 消</el-button> -->
                <el-button type="danger" @click="dialog = false">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            default: ''
        },
        value: {
            type: Boolean,
            default: true
        },
        table: {
            type: Array,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: []
        }
    },
    data() {
        return {
            dialog: !!this.value,
            initCol: ['打标旺旺', '商品id', '打标关键词', '打标结果'],
            tableData: this.table.slice(0, 10),
            total: this.table.length,
            page: 1,
            psize: 10
        }
    },
    methods: {
        handleCurrentChange(page) {
            this.page = page
            this.tableData = this.table.slice((page - 1) * this.psize, page * this.psize)
        }
    },
    mounted() {
        if (this.type == 'push') {
            this.initCol = ['推送搜索旺旺账号', '推送商品id', '推送权重词', '推送结果']
        }
    },
    watch: {
        dialog(val) {
            console.log(val)
            if (!val) this.$emit('input', val)
        }
    }
}
</script>

<style lang="scss" scoped>
.top-tip {
    margin-top: -20px;
    margin-bottom: 20px;
}
</style>